export default "__VITE_ASSET__hm_KgPTi__"